import React, { useState } from 'react';
import { 
  Card, 
  Row, 
  Col, 
  Typography,
  Tabs,
  Space,
} from 'antd';
import { 
  WalletOutlined,
  DollarCircleOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import ZarPackages from '../components/ZarPackages';
import ActionCosts from '../components/ActionCosts';

const { Title, Text } = Typography;

const Wallets: React.FC = () => {
  const [activeTab, setActiveTab] = useState('packages');

  const tabItems = [
    {
      key: 'packages',
      label: (
        <span>
          <DollarCircleOutlined style={{ marginRight: '8px' }} />
          ZAR Packages
        </span>
      ),
      children: <ZarPackages />,
    },
    {
      key: 'action-costs',
      label: (
        <span>
          <SettingOutlined style={{ marginRight: '8px' }} />
          Action Costs
        </span>
      ),
      children: <ActionCosts />,
    },
  ];

  return (
    <div className="page-content" style={{ padding: '24px' }}>
      <Row gutter={[16, 16]} style={{ marginBottom: '16px' }}>
        <Col span={24}>
          <Space align="center" style={{ width: '100%', justifyContent: 'space-between' }}>
            <div>
              <Title level={2} style={{ margin: 0 }}>
                <WalletOutlined style={{ marginRight: '8px' }} />
                Wallets Management
              </Title>
              <Text type="secondary">Manage ZAR wallet packages and action costs configurations</Text>
            </div>
          </Space>
        </Col>
      </Row>

      <Card>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          type="card"
          items={tabItems}
        />
      </Card>
    </div>
  );
};

export default Wallets;

